const CIDS_DOMAIN = 'cids'
const CIDS_STATE = {}

export {
  CIDS_DOMAIN,
  CIDS_STATE
}
